const SEAL_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" width="400" height="400">
  <defs>
    <!-- Глубокий фон печати -->
    <radialGradient id="basePlate" cx="50%" cy="50%" r="50%">
      <stop offset="30%" stop-color="#4a154b"/>
      <stop offset="90%" stop-color="#190624"/>
      <stop offset="100%" stop-color="#0a0210"/>
    </radialGradient>
    
    <!-- Золотой металл -->
    <linearGradient id="goldMetal" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#ffe259"/>
      <stop offset="25%" stop-color="#ffa751"/>
      <stop offset="50%" stop-color="#ffd54f"/>
      <stop offset="80%" stop-color="#df8e27"/>
      <stop offset="100%" stop-color="#8c5511"/>
    </linearGradient>

    <!-- Внутренний механический круг золото -->
    <linearGradient id="innerGold" x1="100%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stop-color="#fdfc47"/>
      <stop offset="50%" stop-color="#d4af37"/>
      <stop offset="100%" stop-color="#aa7700"/>
    </linearGradient>

    <!-- Свечение магии (Cyan/Blue) -->
    <radialGradient id="magicGlowColor" cx="50%" cy="50%" r="50%">
      <stop offset="0%" stop-color="#00ffff" stop-opacity="1"/>
      <stop offset="30%" stop-color="#00d2ff" stop-opacity="0.8"/>
      <stop offset="70%" stop-color="#3a7bd5" stop-opacity="0"/>
    </radialGradient>

    <!-- Фильтры свечения -->
    <filter id="neonGlow" x="-50%" y="-50%" width="200%" height="200%">
      <feGaussianBlur stdDeviation="6" result="blur1" />
      <feGaussianBlur stdDeviation="15" result="blur2" />
      <feMerge>
        <feMergeNode in="blur2" />
        <feMergeNode in="blur1" />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>

    <filter id="heavyDropShadow" x="-20%" y="-20%" width="140%" height="140%">
      <feDropShadow dx="0" dy="8" stdDeviation="10" flood-color="#000" flood-opacity="0.8"/>
    </filter>
    
    <filter id="innerShadow">
      <feOffset dx="0" dy="4"/>
      <feGaussianBlur stdDeviation="5" result="offset-blur"/>
      <feComposite operator="out" in="SourceGraphic" in2="offset-blur" result="inverse"/>
      <feFlood flood-color="black" flood-opacity="0.7" result="color"/>
      <feComposite operator="in" in="color" in2="inverse" result="shadow"/>
      <feComposite operator="over" in="shadow" in2="SourceGraphic"/>
    </filter>
  </defs>

  <g filter="url(#heavyDropShadow)">
    <path d="M 120 20 L 280 20 L 380 120 L 380 280 L 280 380 L 120 380 L 20 280 L 20 120 Z" fill="url(#goldMetal)" stroke="#603000" stroke-width="4"/>
    <circle cx="200" cy="200" r="145" fill="url(#basePlate)" filter="url(#innerShadow)"/>
    <g fill="#fffae6" stroke="#aa7700" stroke-width="2">
      <circle cx="150" cy="50" r="6"/>
      <circle cx="250" cy="50" r="6"/>
      <circle cx="350" cy="150" r="6"/>
      <circle cx="350" cy="250" r="6"/>
      <circle cx="250" cy="350" r="6"/>
      <circle cx="150" cy="350" r="6"/>
      <circle cx="50" cy="250" r="6"/>
      <circle cx="50" cy="150" r="6"/>
    </g>
    <circle cx="200" cy="200" r="110" fill="none" stroke="url(#innerGold)" stroke-width="12" stroke-dasharray="10 15" />
    <circle cx="200" cy="200" r="95" fill="none" stroke="url(#goldMetal)" stroke-width="8" />
    <g fill="#00d2ff" opacity="0.6" font-family="serif" font-size="20" font-weight="bold" text-anchor="middle">
      <text x="200" y="80">Φ</text>
      <text x="200" y="335">Ψ</text>
      <text x="75" y="208">Ω</text>
      <text x="325" y="208">Σ</text>
      <text x="110" y="115">∇</text>
      <text x="290" y="300">∆</text>
      <text x="290" y="115">Λ</text>
      <text x="110" y="300">Ξ</text>
    </g>
    <path d="M 200 120 C 230 120 250 140 250 170 C 250 190 235 210 220 230 L 220 260 C 220 270 210 280 200 280 C 190 280 180 270 180 260 L 180 230 C 165 210 150 190 150 170 C 150 140 170 120 200 120 Z" fill="url(#goldMetal)" stroke="#502800" stroke-width="3" filter="url(#heavyDropShadow)"/>
    <circle cx="200" cy="200" r="40" fill="url(#magicGlowColor)" />
    <path d="M 200 145 C 215 145 225 155 225 170 C 225 185 210 200 205 210 L 210 245 L 190 245 L 195 210 C 190 200 175 185 175 170 C 175 155 185 145 200 145 Z" fill="#ffffff" filter="url(#neonGlow)"/>
    <path d="M 200 145 C 215 145 225 155 225 170 C 225 185 210 200 205 210 L 210 245 L 190 245 L 195 210 C 190 200 175 185 175 170 C 175 155 185 145 200 145 Z" fill="#ccffff" />
  </g>
</svg>`;

let sealImageCache: HTMLImageElement | null = null;

function getSealImage() {
    if (sealImageCache) return sealImageCache;
    const img = new Image();
    const svgBlob = new Blob([SEAL_SVG], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);
    img.src = url;
    sealImageCache = img;
    return img;
}

const Math_PI = Math.PI;

const easeOutQuint = (x: number): number => {
    return 1 - Math.pow(1 - x, 5);
};

const easeOutBack = (x: number): number => {
    const c1 = 1.70158;
    const c3 = c1 + 1;
    return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
};

class SecretCardParticle {
    x: number; y: number; vx: number; vy: number;
    rot: number; rotV: number;
    w: number; h: number; color: string;
    life: number; maxLife: number;
    delay: number;
    trail: { x: number, y: number, alpha: number }[];

    constructor(startX: number, startY: number, delay: number) {
        this.x = startX; this.y = startY;
        const speed = 200 + Math.random() * 600;
        // spray somewhat upwards radially
        const angle = -Math.PI / 2 + (Math.random() - 0.5) * 2;
        this.vx = Math.cos(angle) * speed;
        this.vy = Math.sin(angle) * speed;
        this.rot = Math.random() * Math.PI * 2;
        this.rotV = (Math.random() - 0.5) * 15;
        this.w = 12 + Math.random() * 15;
        this.h = this.w * 1.5;
        const colorPicks = ['#00ffff', '#00d2ff', '#e0b0ff', '#ff00ff'];
        this.color = colorPicks[Math.floor(Math.random() * colorPicks.length)];
        this.maxLife = 1.0 + Math.random() * 1.0;
        this.life = 0;
        this.delay = delay;
        this.trail = [];
    }
    update(dt: number) {
        if (this.delay > 0) { this.delay -= dt; return; }
        this.life += dt;
        this.vy += 600 * dt; // gravity
        this.vx *= 0.98; // air friction
        this.vy *= 0.98;
        this.x += this.vx * dt;
        this.y += this.vy * dt;
        this.rot += this.rotV * dt;
        this.trail.push({ x: this.x, y: this.y, alpha: 1.0 });
        if (this.trail.length > 8) this.trail.shift();
        for (let i = 0; i < this.trail.length; i++) this.trail[i].alpha *= 0.8;
    }
    draw(ctx: CanvasRenderingContext2D) {
        if (this.delay > 0) return;
        const alpha = Math.max(0, 1 - (this.life / this.maxLife));
        ctx.globalAlpha = alpha;

        // Trail
        if (this.trail.length > 1) {
            ctx.beginPath();
            ctx.moveTo(this.trail[0].x, this.trail[0].y);
            for (let i = 1; i < this.trail.length; i++) ctx.lineTo(this.trail[i].x, this.trail[i].y);
            ctx.strokeStyle = this.color;
            ctx.lineWidth = 4 * alpha;
            ctx.lineCap = 'round';
            ctx.stroke();
        }

        ctx.save();
        ctx.translate(this.x, this.y);
        ctx.rotate(this.rot);
        ctx.shadowBlur = 15;
        ctx.shadowColor = this.color;
        ctx.fillStyle = this.color;

        ctx.fillRect(-this.w / 2, -this.h / 2, this.w, this.h);
        ctx.fillStyle = '#ffffff'; // inner bright core
        ctx.fillRect(-this.w / 2 + 2, -this.h / 2 + 2, this.w - 4, this.h - 4);
        ctx.restore();
    }
}

class LightRay {
    angle: number; length: number; width: number; speed: number; phase: number;
    color: string;
    constructor() {
        this.angle = Math.random() * Math.PI * 2;
        this.length = 100 + Math.random() * 250;
        this.width = 4 + Math.random() * 10;
        this.speed = 2 + Math.random() * 6;
        this.phase = Math.random() * Math.PI * 2;
        this.color = Math.random() > 0.5 ? '0, 210, 255' : '200, 100, 255';
    }
    draw(ctx: CanvasRenderingContext2D, cx: number, cy: number, time: number, intensity: number) {
        const currentLength = this.length + Math.sin(time * this.speed + this.phase) * 40;
        const alpha = (0.5 + Math.sin(time * (this.speed * 0.5) + this.phase) * 0.5) * intensity;
        ctx.save();
        ctx.translate(cx, cy);
        ctx.rotate(this.angle);
        const grad = ctx.createLinearGradient(0, 0, currentLength, 0);
        grad.addColorStop(0, `rgba(${this.color}, ${alpha})`);
        grad.addColorStop(1, `rgba(${this.color}, 0)`);
        ctx.fillStyle = grad;
        ctx.beginPath();
        ctx.moveTo(0, -this.width / 2);
        ctx.lineTo(currentLength, 0);
        ctx.lineTo(0, this.width / 2);
        ctx.fill();
        ctx.restore();
    }
}

export class BrokenSecretEffect {
    startX: number; startY: number; targetX: number; targetY: number;
    isComplete: boolean = false;
    time: number = 0;

    cards: SecretCardParticle[] = [];
    rays: LightRay[] = [];

    // phases
    // 0 = MATERIALIZE (0 to 0.7s)
    // 1 = OVERLOAD (0.7s to 1.6s)
    // 2 = SHATTER (1.6s)
    // 3 = DISSIPATE (1.6s to 3.6s)

    sealImg: HTMLImageElement;
    shards: { angleStart: number, angleEnd: number, vx: number, vy: number, rot: number, rotV: number, x: number, y: number }[] = [];

    constructor(startX: number, startY: number, targetX: number, targetY: number) {
        this.startX = startX; this.startY = startY;
        this.targetX = targetX; this.targetY = targetY;
        this.sealImg = getSealImage();

        for (let i = 0; i < 20; i++) {
            this.rays.push(new LightRay());
        }

        const numCards = 40;
        for (let i = 0; i < numCards; i++) {
            this.cards.push(new SecretCardParticle(this.targetX, this.targetY, 1.6 + i * 0.015)); // stagger
        }

        for (let i = 0; i < 10; i++) {
            const angleStart = (i / 10) * Math.PI * 2;
            const angleEnd = ((i + 1) / 10) * Math.PI * 2;
            const midAngle = (angleStart + angleEnd) / 2;
            const speed = 400 + Math.random() * 300;
            this.shards.push({
                angleStart, angleEnd,
                vx: Math.cos(midAngle) * speed,
                vy: Math.sin(midAngle) * speed - 300,
                rot: 0,
                rotV: (Math.random() - 0.5) * 10,
                x: 0, y: 0
            });
        }
    }

    update(dt: number) {
        this.time += dt;

        for (const c of this.cards) c.update(dt);

        if (this.time >= 1.6) {
            for (const s of this.shards) {
                s.vy += 1200 * dt; // gravity
                s.x += s.vx * dt;
                s.y += s.vy * dt;
                s.rot += s.rotV * dt;
            }
        }

        if (this.time > 3.6) this.isComplete = true; // Wait for cards to exhaust
    }

    draw(ctx: CanvasRenderingContext2D) {
        ctx.save();
        const t = this.time;
        const cx = this.targetX;
        const cy = this.targetY;
        const sealSize = 250;

        let darkAlpha = 0;
        if (t < 0.7) darkAlpha = (t / 0.7) * 0.75;
        else if (t < 2.6) darkAlpha = 0.75;
        else darkAlpha = Math.max(0, 0.75 * (1.0 - (t - 2.6) / 1.0));

        if (darkAlpha > 0) {
            ctx.fillStyle = `rgba(0,0,0,${darkAlpha})`;
            ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        }

        if (t < 1.6) {
            ctx.save();
            ctx.translate(cx, cy);
            let scale = 1;
            let alpha = 1;

            if (t < 0.7) {
                const p = t / 0.7;
                scale = 3.0 - easeOutBack(p) * 2.0;
                alpha = easeOutQuint(p);
            } else {
                const shakeIntensity = (t - 0.7) / 0.9;
                ctx.translate((Math.random() - 0.5) * 12 * shakeIntensity, (Math.random() - 0.5) * 12 * shakeIntensity);
            }

            ctx.scale(scale, scale);
            ctx.globalAlpha = alpha;
            if (this.sealImg.complete) {
                ctx.drawImage(this.sealImg, -sealSize / 2, -sealSize / 2, sealSize, sealSize);
            }

            if (t > 0.7) {
                ctx.globalCompositeOperation = 'screen';
                const rayInt = easeOutQuint((t - 0.7) / 0.9);
                for (const r of this.rays) {
                    r.draw(ctx, 0, 0, t, rayInt);
                }
                const grad = ctx.createRadialGradient(0, 0, 0, 0, 0, 180 * rayInt);
                grad.addColorStop(0, `rgba(0, 255, 255, ${rayInt * 0.8})`);
                grad.addColorStop(1, 'rgba(0, 255, 255, 0)');
                ctx.fillStyle = grad;
                ctx.beginPath();
                ctx.arc(0, 0, 180 * rayInt, 0, Math.PI * 2);
                ctx.fill();
            }
            ctx.restore();
        }

        if (t > 1.55 && t < 1.9) {
            const p = 1.0 - ((t - 1.55) / 0.35);
            ctx.save();
            ctx.globalCompositeOperation = 'screen';
            const grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, 500);
            grad.addColorStop(0, `rgba(255, 255, 255, ${p})`);
            grad.addColorStop(0.4, `rgba(0, 255, 255, ${p * 0.8})`);
            grad.addColorStop(1, 'rgba(0, 0, 0, 0)');
            ctx.fillStyle = grad;
            ctx.fillRect(cx - 500, cy - 500, 1000, 1000);
            ctx.restore();
        }

        if (t >= 1.6 && this.sealImg.complete) {
            ctx.save();
            const fade = t > 2.6 ? 1.0 - (t - 2.6) / 1.0 : 1.0;
            ctx.globalAlpha = Math.max(0, fade);

            for (const s of this.shards) {
                ctx.save();
                ctx.translate(cx + s.x, cy + s.y);
                ctx.rotate(s.rot);

                ctx.beginPath();
                ctx.moveTo(0, 0);
                const r = sealSize * 0.9;
                ctx.lineTo(Math.cos(s.angleStart) * r, Math.sin(s.angleStart) * r);
                ctx.arc(0, 0, r, s.angleStart, s.angleEnd);
                ctx.lineTo(0, 0);
                ctx.clip();

                ctx.drawImage(this.sealImg, -sealSize / 2, -sealSize / 2, sealSize, sealSize);
                ctx.restore();
            }
            ctx.restore();
        }

        ctx.globalCompositeOperation = 'screen';
        for (const c of this.cards) c.draw(ctx);
        ctx.globalCompositeOperation = 'source-over';

        ctx.restore();
    }
}
